exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text h2 {\n  font-size: 1.125rem;\n  margin-bottom: .5rem;\n}\n.text p {\n  margin-bottom: 1rem;\n}\n", ""]);

// exports
